<!-- Input (native "search" event fires on clear, Enter default is prevented to not fire it twice) -->
<input
  #search
  (blur)="onBlur()"
  (focus)="onFocus()"
  [class.with-icon]="showIcon()"
  [class.with-clear]="showClear()"
  [value]="value()"
  type="search"
  [placeholder]="placeholder() || 'Search...'"
  (keydown.enter)="$event.preventDefault(); performSearch(search.value); search.blur()"
  (search)="showClear() && performSearch(search.value)"
>

<!-- Icon -->
@if (showIcon()) {
  <div class="icon ui-icon-search-gray"></div>
}

<!-- Button -->
@if (showButton()) {
  <div class="btn" (click)="performSearch(search.value)">
    <div class="ui-icon-search"></div>
  </div>
}
